<template>
    <transition name="fade">
        <div v-if="show" class="reblogDialog">
            <a href="#" class="closeBtn" @click.prevent="hide()"><icon icon="times" size="2x"/></a>

            <div class="container reblogCont">
                <div class="row justify-content-md-center">
                    <div class="col-md-8 pb-4">

                        <h2>Reblog To:</h2><input type="text" placeholder="filter blogs" v-model="search" class="dark-form"/>



                        <div v-for="blog in selected" class="reblogBtn">
                            <div class="media" @click.prevent="doPost(blog)">
                                <blog-avatar :blog="blog" :w="100" :h="100" class="mr-3"/>
                                <div class="media-body">
                                    <h5 class="mt-0">{{blog.title}}</h5>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </transition>
</template>

<script>
    import Icon from "./Icon";
    import BlogAvatar from "./BlogAvatar";

    export default {

        name: 'postToBlogDialog',
        data() {
            return {
                show: false,
                callback: null,
                search: ''
            }
        },
        computed:{
            blogs(){
                return this.$store.getters['user/blogs'];
            },
            selected(){
                return this.blogs.filter( (blog) => blog.title.toLowerCase().indexOf(this.search)>=0 )
            }
        },
        mounted(){
            this.$bus.$on('blogPicker', (cb)=>{
                this.show = true;
                this.callback = cb;
                this.$bus.$emit('modal.open', 'blogPicker');
            });
        },
        methods: {
            hide(){
                this.show = false;
                this.callback = null;
                this.$bus.$emit('modal.close', 'blogPicker');
            },
            doPost(blog){
                this.callback(blog);
                this.hide();
            }

        },
        components: {
            BlogAvatar,
            Icon
        }
    }
</script>

<style lang="sass" scoped>

    @import "../../assets/sass/vars.scss"

    .reblogDialog
        position: fixed
        top: 0
        left: 0
        right: 0
        bottom: 0
        background-color: rgba(0,0,0,.8)
        z-index: $z-blogPickerDialog

    h2
         color: #FFF
         margin-top: 2em

    input.dark-form
        background-color: rgba(0,0,0,.2)
        border: 0
        border-bottom: 1px solid #000
        color: #CCC
        font-weight: 200
        padding: .2em
        font-size: 1em
        width: 100%


        &::placeholder
            color: #666
            opacity: .7
            font-weight: 200
            font-style: italic
            font-size: .8em

        &:-ms-input-placeholder
            color: #666
            opacity: .7
            font-weight: 200
            font-style: italic
            font-size: .8em

        &::-ms-input-placeholder
            color: #666
            opacity: .7
            font-weight: 200
            font-style: italic
            font-size: .8em



    .reblogCont
        overflow: scroll
        max-height: 100%

    .closeBtn
        position: absolute
        top: 30px
        right: 30px
        width: auto
        z-index: 5

    .reblogBtn
        cursor: pointer
        background-color: rgba(0,0,0,.8)
        padding: 1em
        color: #fff
        border: 1px solid rgba(0,0,0,.9)
        margin-top: 1em
        border-radius: 3px

        &:hover
            border-color: $colorPrimary

    .fade-enter-active, .fade-leave-active
        transition: all .15s ease-out

    .fade-enter, .fade-leave-to
        opacity: 0
        transform: translateY(100px)

</style>



// WEBPACK FOOTER //
// src/components/ui/BlogPickerDialog.vue